import Vue from 'vue'

const profile = {
  namespaced: true,
  state: {
    email: '',
    image: '',
    id: '',
    roles: []
  },
  mutations: {
    FETCH_USER(state, user) {
      state.id = user.id;
      state.email = user.email;
      state.image = user.base64image;
      state.roles = user.roles;
    }
  },
  actions: {
    getProfile({ state, commit }) {
      if (state.current === undefined) {
        Vue.axios.get(process.env.VUE_APP_API_URL + 'profile/get')
          .then((response) => {
            commit('FETCH_USER', response.data)
          })
          .catch(error => {
            console.log(error.statusText)
          })
      } else {
        return commit('FETCH_USER', state.current)
      }
    }
  }
}

export default profile
